/* eslint-disable jsx-a11y/alt-text */
import { Image, Path, Svg, Text, View } from '@react-pdf/renderer'

import { styles } from '@/components/organisms/Viewer/styles'
import { getPdfBadgeColors } from '@/components/organisms/Viewer/pdfTheme'
import { imgPath } from '@/services/adapters'

const LocationPin = () => (
  <Svg viewBox="0 0 24 24" width="12" height="12">
    <Path
      d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      stroke="#000"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)

export const DenseDefault = ({ category, items, settings }) => {
  const caracteristics = [
    'brand',
    'stock',
    'price',
    'price.amount_1',
    'price.amount_2',
    'color',
    'dimensions',
    'weight',
  ]
  const details = [
    'ref',
    'availability',
    'condition',
    'reemploymentIndex',
    'tag',
  ]

  return (
    <>
      <View style={[styles.section]}>
        {category && (
          <Text style={[styles.chip, getPdfBadgeColors(settings?.color)]}>
            {category}
          </Text>
        )}
        {items?.map(({ name, id, pictures, productItems }) => {
          const data = productItems
            .filter((item) => caracteristics.includes(item.key))
            .sort((a, b) => a.order - b.order)
          const place = productItems.find((item) => item.key === 'place')
          const detailsData = productItems
            .filter((item) => details.includes(item.key))
            .sort((a, b) => a.order - b.order)
          const imageUrl = imgPath(pictures?.[0], 'thumbnail')
          return (
            <View style={[styles.table]} key={`item-${id}`} wrap={false}>
              <View style={styles.tableRow}>
                <Image src={`${imageUrl}`} style={styles.image} />
                <View
                  style={[
                    styles.colLabel,
                    {
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    },
                  ]}
                >
                  <View>
                    <Text style={styles.title}>{name}</Text>
                    <ul>
                      {data.map(({ key, title, subTitle, short }) => (
                        <li key={key} style={{ paddingBottom: '0.1cm' }}>
                          <View style={{ flexDirection: 'row' }}>
                            <Text style={styles.label}>
                              {short ? `${short} : ${title}` : title}
                            </Text>
                          </View>
                          {subTitle && (
                            <Text style={styles.subTitle}>{subTitle}</Text>
                          )}
                        </li>
                      ))}
                    </ul>
                  </View>
                  <View>
                    {place?.description && (
                      <View
                        style={{ flexDirection: 'row', alignItems: 'center' }}
                      >
                        <Text style={[styles.label, { marginRight: 2 }]}>
                          {place?.description}
                        </Text>
                      </View>
                    )}
                    {place?.title && (
                      <View
                        style={{ flexDirection: 'row', alignItems: 'center' }}
                      >
                        <LocationPin />
                        <Text style={[styles.label, { marginLeft: 2 }]}>
                          {place.title} {place.subTitle}
                        </Text>
                      </View>
                    )}
                  </View>
                </View>

                <View
                  style={[
                    styles.colLabelSmall,
                    {
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      alignItems: 'flex-end',
                      textAlign: 'right',
                    },
                  ]}
                >
                  {detailsData.map(({ key, title, subTitle, name, value }) => {
                    if (key === 'reemploymentIndex') {
                      return (
                        <View
                          key={key}
                          style={[styles.tableCell, styles.indicator]}
                        >
                          <Text
                            style={{
                              fontSize: 9,
                              color: 'black',
                              marginRight: 8,
                            }}
                          >
                            {name} {title}
                          </Text>
                          {[1, 2, 3, 4].map((i) => {
                            return (
                              <View key={i}>
                                {i - 1 < value ? (
                                  <Image
                                    src="/icon/square-solid.svg"
                                    style={{
                                      width: 8,
                                      height: 8,
                                      marginRight: 2,
                                      backgroundColor: 'black',
                                    }}
                                  />
                                ) : (
                                  <Image
                                    src="/icon/square-outline.svg"
                                    style={{
                                      width: 8,
                                      height: 8,
                                      marginRight: 2,
                                      backgroundColor: '#CCC',
                                    }}
                                  />
                                )}
                              </View>
                            )
                          })}
                        </View>
                      )
                    }

                    if (key === 'availability') {
                      return (
                        <View key={key} style={{ paddingBottom: '0.1cm' }}>
                          <Text style={styles.label}>{title}</Text>
                          {subTitle && (
                            <Text style={styles.subTitle}>{subTitle}</Text>
                          )}
                        </View>
                      )
                    }

                    return (
                      <View key={key} style={{ paddingBottom: '0.1cm' }}>
                        <Text style={styles.label}>{title}</Text>
                        {subTitle && (
                          <Text style={styles.subTitle}>{subTitle}</Text>
                        )}
                      </View>
                    )
                  })}
                </View>
              </View>
            </View>
          )
        })}
      </View>
    </>
  )
}
